import { AxiosResponse } from 'axios';
import { ShortURL } from 'src/admin-entity/interface/etc/short-url.interface';
import { Page } from 'src/admin-entity/interface/page/page-info.interface';
import { BASE_URL } from 'src/config/api';
import client from '../client';

export const createShortUrl = (orgUrl: string): Promise<AxiosResponse<{ shortUrlId: number }>> =>
    client.post(`${BASE_URL}/v1/admin/short-url`, {
        orgUrl,
    });

export const getShortURLList = (take: number, page: number): Promise<AxiosResponse<Page<ShortURL>>> =>
    client.get(`${BASE_URL}/v1/admin/short-url?page=${page}&take=${take}`);

export const deleteShortURL = (shortURL: ShortURL): Promise<AxiosResponse<boolean>> =>
    client.delete(`${BASE_URL}/v1/admin/short-url/${shortURL.id}`);
